import React from "react";

export const ItemCardInfoRescuePassMultiplus = ({}) => {
	return (
		<div className="item-card-info-rescue-pass-multiplus">
			<p className="item-card-info-rescue-pass-multiplus--title">Senha de resgate do Latam Pass</p>
			<p>
				Atenção! A senha de resgate é diferente da senha de acesso à sua conta Latam Pass. Ela tem 5 números e pode ser alterada ou solicitada no site do programa, na área <strong>Minha Conta</strong>, clicando em <strong>Senhas</strong>.
			</p>
		</div>
	);
};
